import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BrnNavigationMenuImports } from '@spartan-ng/brain/navigation-menu';
import { HlmNavigationMenuImports } from '@spartan-ng/helm/navigation-menu';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-header-nav-menu',
  imports: [RouterLink, BrnNavigationMenuImports, HlmNavigationMenuImports],
  templateUrl: './header-nav-menu.component.html',
  host: { class: 'block' },
})
export class HeaderNavMenuComponent {
  protected readonly permissionService = inject(PermissionService);
  readonly canViewMappings = computed(() => this.permissionService.has('mappings.view'));
  readonly canViewParticipants = computed(
    () => this.permissionService.has('participants.import') || this.permissionService.has('participants.transfer'),
  );
  readonly canViewReporting = computed(() => this.permissionService.canViewAll());
}
